export default "__VITE_ASSET__b9ae634c__"